import { createApi } from "@reduxjs/toolkit/query/react";

import apiConfig from "configs/apiConfig";
import { REDUCER_PATHS } from "store/config";
import { transformResponseHandler } from "utils/transformResponseHandler";

import { customFetchBase } from ".";

const userApi = createApi({
  reducerPath: REDUCER_PATHS.USERS,
  baseQuery: customFetchBase,
  endpoints: (builder) => ({
    //User Management Start//
    userManagementListing: builder.query({
      query: (data) => ({
        url: apiConfig.USER_LISTING,
        body: data,
        method: "POST",
      }),
    }),
    userDetails: builder.mutation({
      query: (data) => ({
        url: `${apiConfig.USER_DETAILS}/${data.id}`,
        method: "GET",
      }),
    }),
    deleteUser: builder.mutation({
      query: (data) => ({
        url: `${apiConfig.DELETE_USER}/${data.id}`,
        body: data,
        method: "DELETE",
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    updateUserStatus: builder.mutation({
      query: (data) => ({
        url: `${apiConfig.UPDATE_USER_STATUS}/${data.id}`,
        body: data,
        method: "PUT",
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    changeUserStatus: builder.mutation({
      query: (data) => ({
        url: apiConfig.CHANGE_USER_STATUS,
        body: data,
        method: "PUT",
      }),
      invalidatesTags: ["userDetails"],
      transformResponse: (resp) => transformResponseHandler(resp),
    }),

    //User Management End//

    userDetailsDownload: builder.mutation({
      query: (data) => ({
        url: `${apiConfig.USER_DETAILS_DOWNLOAD}/${data.type}?languageId=${data?.languageId}&filter=${data.filter}&column=${data.column}`,
        method: "GET",
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),

    //workers
    workersListing: builder.mutation({
      query: (data) => ({
        url: apiConfig.WORKER_LIST,
        method: "POST",
        body: data,
      }),
    }),
    addWorker: builder.mutation({
      query: (data) => ({
        url: apiConfig.ADD_WORKER,
        method: "POST",
        body: data,
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    changeWorkerStatus: builder.mutation({
      query: (data) => ({
        url: apiConfig.CHANGE_WORKER_STATUS,
        body: data,
        method: "PATCH",
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    deleteWorker: builder.mutation({
      query: (data) => ({
        url: apiConfig.DELETE_WORKER,
        body: data,
        method: "DELETE",
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    updateWorkerDeatils: builder.mutation({
      query: (data) => ({
        url: apiConfig.EDIT_WORKER + data?.id,
        method: "PUT",
        body: data,
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    getWorkerDeatils: builder.mutation({
      query: (data) => ({
        url: `${apiConfig.GET_EDIT_WORKER_DETAILS}/${data.id}`,
        method: "GET",
      }),
    }),
    assignAsWorker: builder.mutation({
      query: (data) => ({
        url: apiConfig.WORKER_ASSIGN,
        method: "POST",
        body: data,
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    workerDetailsDownload: builder.mutation({
      query: (data) => ({
        url: `${apiConfig.WORKER_DETAILS_DOWNLOAD}/${data.type}?languageId=${data?.languageId}&filter=${data.filter}&column=${data.column}`,
        method: "GET",
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    getUsersFavClub: builder.mutation({
      query: (data) => ({
        url: apiConfig.GET_USER_FAVOURAITE_CLUB + data.id,
        method: "POST",
        body: { page: data.page, pageSize: data.pageSize },
      }),
    }),
    getUsersMostVoyClub: builder.mutation({
      query: (data) => ({
        url: apiConfig.GET_USER_MOST_VOY_CLUB + data.id,
        method: "POST",
        body: { pageSize: data.pageSize },
      }),
    }),
    getUserTopLevelClub: builder.mutation({
      query: (data) => ({
        url: apiConfig.GET_USERS_TOP_LEVEL_CLUB + data.id,
        method: "POST",
        body: { pageSize: data.pageSize },
      }),
    }),
    getUserBenefitsRedeemed: builder.mutation({
      query: (data) => ({
        url: apiConfig.GET_USERS_BENEFITS_REDEEMED + data.id,
        method: "POST",
        body: { pageSize: data.pageSize },
      }),
    }),
    //admin
    adminManagementListing: builder.query({
      query: (data) => ({
        url: `${apiConfig.LISTING_ADMIN_MANAGEMENT}?page=${data?.page}&pageSize=${data?.pageSize}&searchText=${data?.searchText}&sortColumn=${data?.sortColumn}&sortDirection=${data?.sortDirection}&filter=${data?.filter}`,
        method: "GET",
      }),
    }),
    addAdminUser: builder.mutation({
      query: (data) => ({
        url: apiConfig.ADMIN_MANAGEMENT,
        body: data,
        method: "POST",
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    editAdminUser: builder.mutation({
      query: (data) => ({
        url: `${apiConfig.ADMIN_MANAGEMENT}/${data?.id}`,
        body: data?.postData,
        method: "PUT",
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    deleteAdminUser: builder.mutation({
      query: (data) => ({
        url: apiConfig.ADMIN_MANAGEMENT,
        body: data,
        method: "DELETE",
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    statusChangeAdminUser: builder.mutation({
      query: (data) => ({
        url: apiConfig.ADMIN_MANAGEMENT,
        body: data,
        method: "PATCH",
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    detailsAdminUser: builder.query({
      query: (data) => ({
        url: `${apiConfig.ADMIN_MANAGEMENT}/${data.id}`,
        method: "GET",
      }),
    }),
    adminUserDetailsDownload: builder.mutation({
      query: (data) => ({
        url: `${apiConfig.ADMIN_USERS_DOWNLOAD}/${data.type}?filter=${data.filter}&column=${data.column}`,
        method: "GET",
      }),
    }),
    workerBenefitsList: builder.mutation({
      query: () => ({
        url: apiConfig.WORKER_BENEFITS_LIST,
        method: "GET",
      }),
    }),
    adminWorkerBenefitsList: builder.mutation({
      query: (data) => ({
        url: apiConfig.ADMIN_WORKER_BENEFITS_LIST,
        body: data,
        method: "POST",
      }),
    }),
    workerAccordingBenefitsList: builder.mutation({
      query: (data) => ({
        url: apiConfig.WORKER_VISE_BENEFITS_LIST,
        body: data,
        method: "POST",
      }),
    }),
    workersStatisticsList: builder.mutation({
      query: (data) => ({
        url: apiConfig.WORKER_STATISTICS_LIST,
        method: "POST",
        body: data,
      }),
    }),
    workersVoyList: builder.mutation({
      query: (data) => ({
        url: apiConfig.WORKER_REAL_VOY_LIST,
        method: "POST",
        body: data,
      }),
    }),
    workersVoyRedeemedList: builder.mutation({
      query: (data) => ({
        url: apiConfig.WORKER_REAL_BENEFITS_LIST,
        method: "POST",
        body: data,
      }),
    }),
    workerStatisticsDetailsDownload: builder.mutation({
      query: (data) => ({
        url: apiConfig.WORKER_STATISTICS_DETAILS_DOWNLOAD,
        method: "POST",
        body: data,
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    workersStatisticsReportList: builder.query({
      query: (data) => ({
        url: apiConfig.WORKER_STATISTICS_REPORT_LIST,
        method: "POST",
        body: data,
      }),
    }),
    workersStatisticsReportDownload: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `${apiConfig.API_STASTISCS_REPORT_LIST}/${id}${apiConfig.WORKER_STATISTICS_REPORT_DOWNLOADS}`,
        body: data,
        method: "PATCH",
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    deleteWorkersStatisticsReport: builder.mutation({
      query: (data) => ({
        url: apiConfig.API_STASTISCS_REPORT_LIST,
        body: data,
        method: "DELETE",
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
  }),
});

export const {
  //Admin
  useAddAdminUserMutation,
  useAdminUserDetailsDownloadMutation,
  useDeleteAdminUserMutation,
  useEditAdminUserMutation,
  useLazyAdminManagementListingQuery,
  useStatusChangeAdminUserMutation,
  useDetailsAdminUserQuery,
  //user
  useLazyUserManagementListingQuery,
  useDeleteUserMutation,
  useUpdateUserStatusMutation,
  useChangeUserStatusMutation,
  useUserDetailsMutation,
  useUserDetailsDownloadMutation,

  //worker
  useGetUserTopLevelClubMutation,
  useGetUserBenefitsRedeemedMutation,
  useGetUsersMostVoyClubMutation,
  useWorkersListingMutation,
  useAddWorkerMutation,
  useDeleteWorkerMutation,
  useChangeWorkerStatusMutation,
  useUpdateWorkerDeatilsMutation,
  useGetWorkerDeatilsMutation,
  useAssignAsWorkerMutation,
  useWorkerDetailsDownloadMutation,
  useGetUsersFavClubMutation,
  useWorkerBenefitsListMutation,
  useWorkerAccordingBenefitsListMutation,
  useAdminWorkerBenefitsListMutation,

  //statistics
  useWorkersStatisticsListMutation,
  useWorkersVoyListMutation,
  useWorkersVoyRedeemedListMutation,
  useWorkerStatisticsDetailsDownloadMutation,

  //statistics report
  useLazyWorkersStatisticsReportListQuery,
  useWorkersStatisticsReportDownloadMutation,
  useDeleteWorkersStatisticsReportMutation,
} = userApi;

export default userApi;
